import React, { useState } from "react";
import "./SharedStyle.css";
import { StoreGroup } from "../../Modules/Companies/CompanyDataTypes";
import { Edit, Trash, Save } from "@rsuite/icons";
import { Button, CheckPicker, Col, IconButton, Row } from "rsuite";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../Modals/AlertModal/AlertModal";
import { displayField, isEmptyVal, isNotEmpty } from "../../../utils/helpers";
import {
  defaultStoreGroupFor,
  groupForObjArr,
} from "../../../core/config/AppConstants";

interface StoreGroupProp {
  storeGroup: StoreGroup;
  onDeleteStoreGroup?: Function;
  onUpdateStoreGroup?: Function;
}

const StoreGroupItem: React.FC<StoreGroupProp> = ({
  storeGroup,
  onDeleteStoreGroup,
  onUpdateStoreGroup,
}) => {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [storeGroupName, setStoreGroupName] = useState(storeGroup?.group_name);
  const [storeGroupFor, setStoreGroupFor] = useState(
    storeGroup?.group_for.split(",")
  );

  const handleDelete = (storeGroup: any) => {
    onDeleteStoreGroup && onDeleteStoreGroup(storeGroup);
  };

  const handleUpdate = (storeGroupId: any, storeGroup: any) => {
    if (!storeGroupName.trim()) {
      UtilityServices.showToaster({
        type: "error",
        message: t("REQUIRED", {
          field: t("GROUP").toLowerCase() + " " + t("NAME").toLowerCase(),
        }),
      });
      return;
    }
    if (storeGroupFor.length < 1) {
      UtilityServices.showToaster({
        type: "error",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("GROUP").toLowerCase() + " " + t("FOR").toLowerCase(),
        }),
      });
      return;
    }
    storeGroup.group_name = storeGroupName.trim();
    storeGroup.group_for = storeGroupFor.join();
    onUpdateStoreGroup && onUpdateStoreGroup(storeGroupId, storeGroup);
    resetEditForm();
  };

  const resetEditForm = () => {
    setIsEdit(false);
  };

  return (
    <div className="pl-4">
      <div className="flex items-center cursor-pointer py-1 hover:text-blue-600">
        <Row>
          {isEdit ? (
            <>
              <Col xl={6}>
                <input
                  type="text"
                  value={storeGroupName}
                  onChange={(e) => {
                    setStoreGroupName(e.target.value);
                  }}
                  className="w-full border rounded px-2 py-1 text-sm"
                  placeholder={t("GROUP") + " " + t("NAME")}
                />
              </Col>
              <Col xl={6}>
                <CheckPicker
                  sticky
                  onChange={(e: any) => {
                    let grpFor = e.filter(isNotEmpty);
                    setStoreGroupFor(grpFor);
                  }}
                  onClean={() => {
                    setStoreGroupFor([]);
                  }}
                  data={groupForObjArr}
                  value={storeGroupFor}
                  placeholder={t("GROUP") + " " + t("FOR")}
                />
              </Col>
            </>
          ) : (
            <>
              <Col xl={6}>{storeGroup?.group_name}</Col>
              <Col xl={6}>{storeGroup?.group_for}</Col>
            </>
          )}
          <Col xl={6}>{displayField(storeGroup?.stores_count)}</Col>
          <span className="ms-8 flex ">
            {isEdit ? (
              <Col>
                <IconButton
                  appearance="subtle"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleUpdate(storeGroup.id, storeGroup);
                  }}
                  title={t("SAVE")}
                  icon={<Save />}
                />
              </Col>
            ) : (
              <Col>
                <IconButton
                  appearance="subtle"
                  onClick={(e) => {
                    e.stopPropagation();
                    setStoreGroupName(storeGroup.group_name);
                    setIsEdit(true);
                  }}
                  title={t("UPDATE")}
                  icon={<Edit />}
                />
              </Col>
            )}
            <Col>
              <IconButton
                appearance="subtle"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDeleteModal(true);
                }}
                title={t("DELETE")}
                icon={<Trash />}
              />
            </Col>
          </span>
        </Row>
      </div>

      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            handleDelete(storeGroup);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("GROUP").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
    </div>
  );
};

export default StoreGroupItem;
